import SharingComponent from "./sharing.component";

export default SharingComponent; 